module.exports = __webpack_public_path__ + "static/media/yewu-cj2.f2408669.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageIntelligentDataSecurityGateway/yewu-cj2.png
// module id = 628
// module chunks = 0